import { useParams } from "react-router-dom";
import { Heading } from "../../design/heading";
import NylasCallbackPage from "./pages/Nylas";
import DropboxCallback from "./pages/Dropbox";

export default function CallbackPage() {
  const { type } = useParams<{ type: string }>();

  const renderCallbackComponent = () => {
    switch (type) {
      case "nylas":
        return <NylasCallbackPage />;
      case "dropbox":
        return <DropboxCallback />;
      default:
        return <div>Invalid Callback</div>;
    }
  };

  return (
    <div>
      <Heading>Callback: {type}</Heading>
      {renderCallbackComponent()}
    </div>
  );
}
